import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../../../hooks/hooks';
import PageLoader from '../../../../../../../../components/PageLoader';
import AccountUserComponent from '../components/account-user.component';
import { accountTypes } from '../../../../../../../../redux/account-types/action';
import { selectAccountTypesListItems } from '../../../../../../../../redux/account-types/selector';
import { accountUsers } from '../../../../../../../../redux/account-users/action';
import { selectAccountUsersQueryItems } from '../../../../../../../../redux/account-users/selector';

const ManagementAccountUser = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const accountTypesListData = useSelector(selectAccountTypesListItems)
    const queryItems = useSelector(selectAccountUsersQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedAccountUsers, setSelectedAccountUsers] = useState<any>([])
    const [selectedAddress, setSelectedAddress] = useState<any>([])

    const fetchUsersById = () => {
        dispatch(accountUsers.query({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/iam/users/query`,
            entity: 'accountUsers',
            jsonData: {
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }


    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedAccountUsers((prevState) => ({
            ...prevState, // Preserve previous state
            [field]: event, // Update only the specific field
        }));
    }


    const handleInnerAddressFormChange = (value: any, field: string) => {
        const [parent, key] = field.split('.');

        setSelectedAddress((prev: any) => ({
            ...prev,
            [parent]: {
                ...prev[parent],
                [key]: value
            }
        }));
    };




    useEffect(
        () => {
            dispatch(accountTypes.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
                entity: 'accountTypes',
                jsonData: {}
            })).then(() => {
                if (parmas?.id > 0) {
                    fetchUsersById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        }, []
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedAccountUsers(queryItems?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        const accountuserData = {
            AccountId: Number(parmas?.id),
            FirstName: selectedAccountUsers?.FirstName,
            LastName: selectedAccountUsers?.LastName,
            CompanyName: selectedAccountUsers?.CompanyName,
            Email: selectedAccountUsers?.Email,
            Password: selectedAccountUsers?.Password,
            UserType: selectedAccountUsers?.UserType,
            PhoneNumber: selectedAccountUsers?.PhoneNumber,
            FaxNumber: selectedAccountUsers?.PhoneNumber,
            Address1: selectedAddress?.PrimaryAddress?.Address1,
            Address2: selectedAddress?.PrimaryAddress?.Address2,
            City: selectedAddress?.PrimaryAddress?.City,
            CountryId: selectedAddress?.PrimaryAddress?.CountryId,
            StateProvinceId: selectedAddress?.PrimaryAddress?.StateProvinceId,
            ZipPostalCode: selectedAddress?.PrimaryAddress?.ZipPostalCode
        }
        await dispatch(accountUsers.resetAction({ actionType: 'create' }))
        await dispatch(accountUsers.create({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/iam/users/account-user`,
            entity: 'accountUsers',
            jsonData: {
                Records: [
                    accountuserData
                ]
            }
        })).then(() => {
            back()
        })
    }

    const back = () => {
        if (parmas?.id?.length > 0) {
            navigate(`/management/organization/rms/accounts/${parmas.id}`);
        }
    };
    return (
        <>
            {isLoading ? <PageLoader /> :
                <AccountUserComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedAccountUsers={selectedAccountUsers}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    handleInnerAddressFormChange={handleInnerAddressFormChange}
                    selectedAddress={selectedAddress}
                    id={parmas?.id}
                    accountTypesList={accountTypesListData?.result?.items}
                />
            }
        </>
    )
}

export default ManagementAccountUser;